import WorldChart from "./WorldChart";
import './WorldChart.css';

export default WorldChart;